import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsTrophyHighlightedSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 1a1 1 0 011-1h14a1 1 0 011 1v1h2a2 2 0 012 2v4a5 5 0 01-5 5h-1.186a10.986 10.986 0 01-4.6 3.579l-.214.089v1.851l4.625 3.7A1 1 0 0117 24H7a1 1 0 01-.625-1.78L11 18.52v-1.852l-.214-.089A10.986 10.986 0 016.186 13H5a5 5 0 01-5-5V4a2 2 0 012-2h2zm16 5.418c0 1.615-.353 3.172-1 4.582a3 3 0 003-3V4h-2zM4 4H2v4a3 3 0 003 3c-.647-1.41-1-2.967-1-4.582z"
        fill=""
      />
    </svg>
  )
);
SvgAchievementsTrophyHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsTrophyHighlightedSmall;
